export const makeTempRowId = (prefix = 'new') =>
  `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const getGridRowKey = (row: any) =>
  row?.rid || row?.recid || row?.id || row?.code || row?.shortcode;

export const markRowDeleted = (rows: any[], id: any) =>
  rows.map((r: any) => {
    const key = getGridRowKey(r);
    if (String(key) !== String(id)) return r;

    if (String(r.id || '').startsWith('new-')) {
      return { ...r, _state: 'discard' };
    }

    return { ...r, _state: 'deleted', status: 0 };
  }).filter((r: any) => r._state !== 'discard');

export const countDirtyRows = (rows: any[]) =>
  (rows || []).filter((r) => r._state && r._state !== 'clean').length;

export const hasDirtyRows = (rows: any[]) => countDirtyRows(rows) > 0;
